import React, { useEffect, useState } from "react";
import ButtonComponent from "../Button";
import mondaySdk from "monday-sdk-js";
import { getItemNames } from "../../services/monday-service";
import PageLoader from "../PageLoader";
import useDeleteItems from "../../hooks/api/useDeleteItems";

const monday = mondaySdk();

const UnlinkModal = () => {
  const { unlinkHook } = useDeleteItems();
  const [userId, setUserId] = useState();
  const [itemId, setItemId] = useState();
  const [boardId, setBoardId] = useState();
  const [boardName, setBoardName] = useState();
  const [itemName, setItemName] = useState();
  const [loading, setLoading] = useState(false);

  const getUrlParams = (url) => {
    const searchParams = new URLSearchParams(new URL(url).search);
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params;
  };

  useEffect(() => {
    const params = getUrlParams(window.location.href);

    setUserId(params["userId"]);
    setItemId(params["targetItemId"]);
    setBoardId(params["targetBoardId"]);
    setBoardName(params["boardName"]);
  }, []);

  useEffect(() => {
    if (itemId) {
      const fetchItemName = async () => {
        const response = await getItemNames(itemId);

        setItemName(response[0]?.name);
      };

      fetchItemName();
    }
  }, [itemId]);

  const handleCloseModal = () => {
    monday.execute("closeAppFeatureModal").then((res) => {});
  };

  const handleUnlinkItem = async () => {
    setLoading(true);
    await unlinkHook(userId, itemId, boardId);
    setLoading(false);
    monday.execute("closeAppFeatureModal").then((res) => {});
  };

  if (!itemName || loading) {
    return <PageLoader />;
  }

  return (
    <div className="h-full px-8 pt-6 pb-4 overflow-hidden delete-custom-modal">
      <div className="flex items-center">
        <h1 className="m-0 font-semibold">Unlink item?</h1>
      </div>
      <div>
        <p className="m-0 text-sm text-[#979797]">Same Item Multiple Boards</p>
      </div>
      <div className="mt-4">
        <p className="m-0">
          Are you sure you want to unlink{" "}
          <span className="font-semibold">{itemName}</span> from{" "}
          <span className="font-semibold">{boardName}</span>?
        </p>
      </div>
      <div className="flex justify-end gap-2 mt-6">
        <ButtonComponent
          onClick={handleCloseModal}
          kind="tertiary"
          text="Cancel"
        />
        <ButtonComponent
          onClick={handleUnlinkItem}
          kind="primary"
          color="negative"
          text="Unlink"
        />
      </div>
    </div>
  );
};

export default UnlinkModal;
